import React from 'react';
import LoadIndicator from 'devextreme-react/load-indicator';

interface ProgressSpinnerProps {
    id?: string;
    loading?: boolean;
    size?: number | string;
    text?: string;
    overlay?: boolean;
    center?: boolean;
    className?: string;
    style?: React.CSSProperties;
    indicatorSrc?: string;
}

export const ProgressSpinner: React.FC<ProgressSpinnerProps> = ({
    id,
    loading = true,
    size = 40,
    text,
    overlay = false,
    center = true,
    className = '',
    style,
    indicatorSrc,
}) => {
    if (!loading) return null;

    const containerStyle: React.CSSProperties = {
        position: overlay ? 'absolute' : 'relative',
        top: 0,
        left: 0,
        width: overlay ? '100%' : 'auto',
        height: overlay ? '100%' : 'auto',
        backgroundColor: overlay ? 'rgba(255, 255, 255, 0.6)' : 'transparent',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: center ? 'center' : 'flex-start',
        alignItems: center ? 'center' : 'flex-start',
        zIndex: overlay ? 1000 : 'auto',
        ...style,
    };

    return (
        <div
            className={className}
            style={containerStyle}
        >
            <LoadIndicator
                id={id}
                visible
                height={size}
                width={size}
                indicatorSrc={indicatorSrc}
            />
            {text && <p style={{ marginTop: 8, fontSize: 14, color: '#000' }}>{text}</p>}
        </div>
    );
};
